/**
 * ChannelsClassic – SVG icon.
 */
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Classic channels / grid list view. */
export default function ChannelsClassicIcon({
  focused,
  width,
  height,
  margin,
}: Props) {
  return (
    <svg
      width={(width ? width : 32) * Screen.widthRatio}
      height={(height ? height : 35) * Screen.widthRatio}
      viewBox='0 0 44 47'
      style={{ margin: margin ? margin : 0 }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <mask id='path-1-inside-1_9922_2546' fill='white'>
        <rect x='10.3066' width='22.3309' height='20.497' rx='2.08586' />
      </mask>
      <rect
        x='10.3066'
        width='22.3309'
        height='20.497'
        rx='2.08586'
        stroke={focused ? '#000' : '#FFF'}
        strokeWidth='5.56228'
        mask='url(#path-1-inside-1_9922_2546)'
      />
      <mask id='path-2-inside-2_9922_2546' fill='white'>
        <rect
          x='10.3066'
          y='26.0871'
          width='22.3309'
          height='20.497'
          rx='2.08586'
        />
      </mask>
      <rect
        x='10.3066'
        y='26.0871'
        width='22.3309'
        height='20.497'
        rx='2.08586'
        stroke={focused ? '#000' : '#FFF'}
        strokeWidth='5.56228'
        mask='url(#path-2-inside-2_9922_2546)'
      />
      <path
        d='M6.71582 0.0107422C7.76778 0.11741 8.58887 1.00584 8.58887 2.08594V18.4111L8.57812 18.624C8.47859 19.606 7.69779 20.3868 6.71582 20.4863L6.50293 20.4971H0V17.7158H5.80762V2.78125H0V0H6.50293L6.71582 0.0107422Z'
        fill={focused ? '#000' : '#FFF'}
      />
      <path
        d='M43.8027 2.78125H37.1367V17.7158H43.8027V20.4971H36.4414L36.2285 20.4863C35.1765 20.3797 34.3555 19.4913 34.3555 18.4111V2.08594C34.3555 1.00579 35.1765 0.117348 36.2285 0.0107422L36.4414 0H43.8027V2.78125Z'
        fill={focused ? '#000' : '#FFF'}
      />
      <path
        d='M6.71582 26.0978C7.76778 26.2045 8.58887 27.0929 8.58887 28.173V44.4982L8.57812 44.7111C8.47859 45.6931 7.69779 46.4739 6.71582 46.5734L6.50293 46.5842H0V43.8029H5.80762V28.8683H0V26.0871H6.50293L6.71582 26.0978Z'
        fill={focused ? '#000' : '#FFF'}
      />
      <path
        d='M43.8027 28.8683H37.1367V43.8029H43.8027V46.5842H36.4414L36.2285 46.5734C35.1765 46.4668 34.3555 45.5784 34.3555 44.4982V28.173C34.3555 27.0929 35.1765 26.2044 36.2285 26.0978L36.4414 26.0871H43.8027V28.8683Z'
        fill={focused ? '#000' : '#FFF'}
      />
    </svg>
  );
}
